export default {
	maxItem: 5,
	maxItemMobile: 3,
	sidebarWidth: '13rem',
	sidebarWidthXXL: '17rem'
}
